/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // expiry is in hours
  function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';domain=newtabgallery.com;SameSite=None; Secure';
  }

  function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  }

  function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
  }

	function runEvery60sec() {
	  // runs every 60 sec and runs on init.
    // Get time.
    var time = new Date();
		theTime = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
		$('#time').text(theTime);

		var weekday = new Array(7);
		weekday[0] = "Sunday";
		weekday[1] = "Monday";
		weekday[2] = "Tuesday";
		weekday[3] = "Wednesday";
		weekday[4] = "Thursday";
		weekday[5] = "Friday";
		weekday[6] = "Saturday";

		$('#day').text(weekday[time.getDay()]);

		var month = [];
		month[0] = "January";
		month[1] = "February";
		month[2] = "March";
		month[3] = "April";
		month[4] = "May";
		month[5] = "June";
		month[6] = "July";
		month[7] = "August";
		month[8] = "September";
		month[9] = "October";
		month[10] = "November";
		month[11] = "December";

		$('#month').text(month[time.getMonth()]);
		$('#daynum').text(time.getDate());
	}

  function setWeather(data) {
    var hours = new Date().getHours();
    var dayOrNight = hours > 6 && hours < 22 ? "day" : "night";

    inputTextValue = data.city + ", " + data.country;
    $("#location").val(inputTextValue);
    $(".wi")
        .addClass("wi-owm-" + dayOrNight + "-" + data.iconId);
    $("#temperature > span").text(data.temp);
    $("#status").text(data.status[0].toUpperCase() + data.status.slice(1));
  }

	function getWeather(postal) {
      var weatherData = getCookie("weather");
      if (weatherData) {
        setWeather(JSON.parse(weatherData));
      } else {
        var api = "https://home.newtabgallery.com/weather.php?";
        var http = api + postal;
        $.getJSON(http, function(data) {
          setWeather(data);
          setCookie("weather", JSON.stringify(data), 1);
        }).fail(function(err) {
          console.log(JSON.stringify(err));
        });
      }
	}

	function getLocation() {
      var locationData = getCookie("location");

      if (locationData) {
        var data = JSON.parse(locationData);
        $('#weather-city').text(data.city);
        getWeather('lat=' + data.latitude + '&lon=' + data.longitude);
      } else {
        $.get("https://home.newtabgallery.com/geo.php", function(data) {
          $('#weather-city').text(data.city);
          getWeather('lat=' + data.latitude + '&lon=' + data.longitude);
          var cookieData = {};
          cookieData.city = data.city;
          cookieData.latitude = data.latitude;
          cookieData.longitude = data.longitude;
          setCookie("location", JSON.stringify(cookieData), 24*7);
        }).fail(function(err) {
          console.log(JSON.stringify(err));
        });
      }
	}

	// get tallest tab__content element
	var height = -1;

	$('.tab__content').each(function() {
		height = height > $(this).outerHeight() ? height : $(this).outerHeight();
		$(this).css('position', 'absolute');
	});

  // set height of tabs + top offset
	$('[data-tabs]').css('min-height', height + 70 + 'px');


	$('.tab-label').click(function(){
    $('.tab-label').removeClass('active');
    $(this).addClass('active');
  });


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
	      //localStorage
	      var amplifyStorage = window.localStorage;
	      var newsletterBox = amplifyStorage.getItem('newsletterBox');

				//amplifyStorage.setItem('newsletterBox', 'show'); //used to reset var

	      if(!newsletterBox || newsletterBox === 'show') {
					amplifyStorage.setItem('newsletterBox', 'show');
					$('#signup').addClass('show');
	      }

	      if(newsletterBox === 'hide') {
	      }

				$('.signup-input').click(function(e){
					window.localStorage.setItem('newsletterBox', 'hide');
					$('#signup').removeClass('show')
				});

        // JavaScript to be fired on all pages
				runEvery60sec();
				setInterval(runEvery60sec, 10*1000);
				getLocation();

				$('.share-amplify').click(function() {
					$(this).toggleClass('hide');
					$('.share-links').toggleClass('hide');
				});

				$('.hide-share-amplify').click(function() {
					$('.share-amplify').toggleClass('hide');
					$('.share-links').toggleClass('hide');
				});

				$('.social-share').click(function(e){
					e.preventDefault();
					var popH = 430;
					var popW = 600;
					var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
					var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
					var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
					var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

					var wleft = ((width / 2) - (popH / 2)) + dualScreenLeft;
					var wtop = ((height / 2) - (popW / 2)) + dualScreenTop;

					var $link   = $(this);
					var href    = $link.attr('href');

			    var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
			    window.open(href, '', options+'height='+popH+',width='+popW+',top='+wtop+',left='+wleft);
				});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
